import { createSlice } from "@reduxjs/toolkit";
import { StatusTypes } from "../../controller/enum/dnd/StatusTypes";

const initialState = {
  idSelected: "",
  idSelectedStatus: StatusTypes.IDLE,
  idPositionedHidden: false,
  idPositionedExternal: false,
  size: {},
};

const statusSlice = createSlice({
  name: "position",
  initialState,
  reducers: {
    setIdle: {
      prepare(config = {}) {
        return {
          payload: { id: config.id, size: config.size },
        };
      },
      reducer(state, action) {
        if (action.payload.id !== undefined) {
          state.idSelected = action.payload.id;
        }
        if (action.payload.size) {
          state.size = action.payload.size;
        }
        state.idSelectedStatus = StatusTypes.IDLE;
        state.idPositionedExternal = false;
        state.idPositionedHidden = false;
      },
    },
    setDrag: {
      prepare(config = {}) {
        return {
          payload: {
            id: config.id,
            size: config.size,
            fromIdle: config.fromIdle,
            fromPosition: config.fromPosition,
          },
        };
      },
      reducer(state, action) {
        if (action.payload.fromIdle) {
          if (state.idSelectedStatus !== StatusTypes.IDLE) {
            return;
          }
        }

        if (action.payload.fromPosition) {
          if (state.idSelectedStatus !== StatusTypes.POSITIONED) {
            return;
          }
        }

        if (action.payload.id !== undefined) {
          state.idSelected = action.payload.id;
        }
        if (action.payload.size) {
          state.size = action.payload.size;
        }
        state.idSelectedStatus = StatusTypes.DRAGGED;
        state.idPositionedExternal = false;
        state.idPositionedHidden = false;
      },
    },
    setPosition: {
      prepare(config = {}) {
        return {
          payload: {
            id: config.id,
            size: config.size,
            hidden: config.hidden ?? false,
            external: config.external ?? false,
          },
        };
      },
      reducer(state, action) {
        if (state.idSelectedStatus !== StatusTypes.DRAGGED) {
          return;
        }

        if (action.payload.id !== undefined) {
          state.idSelected = action.payload.id;
        }
        if (action.payload.size) {
          state.size = action.payload.size;
        }
        state.idSelectedStatus = StatusTypes.POSITIONED;
        state.idPositionedExternal = action.payload.external;
        state.idPositionedHidden = action.payload.hidden;
      },
    },
  },
});

//-----------------------------------------------------------------------------------

export const getStatus = (state) => {
  return state.status.idSelectedStatus;
};

export const getStatusId = (state) => {
  return state.status.idSelected;
}

export const getStatusIdle = (state) => {
  return state.status.idSelectedStatus === StatusTypes.IDLE;
};

export const getStatusPositioned = (state) => {
  return state.status.idSelectedStatus === StatusTypes.POSITIONED;
};

export const getStatusDraggedWithId = (id) => (state) => {
  if (!id) {
    return false;
  }

  if (state.status.idSelectedStatus === StatusTypes.DRAGGED) {
    if (state.status.idSelected === id) {
      return true;
    }
  }

  return false;
}

export const getStatusPositionedWithId = (id) => (state) => {
  if (!id) {
    return false;
  }

  if (state.status.idSelectedStatus === StatusTypes.POSITIONED) {
    if (state.status.idSelected === id) {
      return true;
    }
  }

  return false;
}

export const getNodeStatus = (id) => (state) => {
  return state.status.idSelected === id ? state.status.idSelectedStatus : StatusTypes.IDLE;
};

export const isNodeStatusPositionedAndHidden = (id) => (state) => {
  const nodeStatus =
    state.status.idSelected === id ? state.status.idSelectedStatus : StatusTypes.IDLE;

  if (nodeStatus !== StatusTypes.POSITIONED) {
    return false;
  }

  return state.status.idPositionedHidden;
};

export const getSize = (state) => {
  return state.status.size;
};

export const getWidth = (state) => {
  return state.status.size.width;
};

export const getHeight = (state) => {
  return state.status.size.height;
};

//-----------------------------------------------------------------------------------

export const isStatusIdle = (status) => {
  return status === StatusTypes.IDLE;
}

export const isStatusDragged = (status) => {
  return status === StatusTypes.DRAGGED;
}

export const isStatusPositioned = (status) => {
  return status === StatusTypes.POSITIONED;
}

//-----------------------------------------------------------------------------------

export default statusSlice.reducer;
export const { setIdle, setDrag, setPosition } = statusSlice.actions;
